import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { from, Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ToastButtons, ToastMessageType, ToastService } from "../../../../Common/toast";
import { TenantService } from "../../../../Services";
import { ModuleService } from "../Services/module.service";

export interface ModuleData {
  moduleId: string,
  version: number,
}

@Injectable({
    providedIn: 'root'
})
export class ModuleResolveGuard {
  
  constructor(
    private moduleService: ModuleService, 
    private tenantService: TenantService,
    private toast: ToastService) {
    
  }
  
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ModuleData> {
    let moduleId = route.params["moduleId"];
    let version = route.params["version"];
    
    return from(
      this.moduleService.loadModuleContent(this.tenantService.selectedTenant, moduleId, version)
    ).pipe(
      map(() => {
        let moduleData: ModuleData = {
          moduleId: moduleId,
          version: version
        };
        return moduleData
      }),
      catchError((err: any) => {
        this.toast.sendMessage('Error', err, ToastMessageType.error, ToastButtons.None);
        throw err;
      })
      );
  }
  
}